<template>
	<b-modal
		scrollable
		no-fade
		ok-only
		:title="$t('bookings.assignDriverUnit')"
		static
		v-model="showaux"
		@ok="doUpdateServices"
		:ok-title="$t('bookings.assign')"
		:hide-footer="selected.length === 0"
	>
		<h4 v-if="selected.length === 0">
			No se ha seleccionado servicios para actualizar
		</h4>
		<div v-else>
			<b-form-group :label="$t('bookings.driver')">
				<b-form-select
					size="sm"
					v-model="driverId"
					:options="userDriverOpts"
					required
				/>
			</b-form-group>
			<br />
			<b-form-group :label="$t('bookings.transportUnit')">
				<b-form-select
					size="sm"
					v-model="transportUnitId"
					:options="transportUnitsOpts"
					required
				/>
			</b-form-group>
		</div>
		<b-overlay :show="loading" no-wrap></b-overlay>
	</b-modal>
</template>

<script>

import { db, doc, getDoc, getAuth, onAuthStateChanged, signInWithCustomToken } from "@/plugins/firebase";

export default {
	methods: {
		async doUpdateServices(ev) {
			ev.preventDefault();
			this.loading = true;
			try{
				await this.observableAuth()
			}catch(err){
				console.log(err)
			}
			

			this.getDriverTokenFB().then(() => {
				//
			}).catch((error) => {
				console.log(error)
			}).finally(() => {
				this.$root.api
					.put(`/transport-services-assigment`, {
						ids: this.selected,
						driverId: this.driverId,
						transportUnitId: this.transportUnitId,
						token: this.token
					})
					.then(() => {
						this.loading = false;
						this.$root.showAlert("Actualizacion exitosa");
						this.$emit("update:show", false);
						this.$emit("onUpdate");
					})
					.catch(err => {
						this.$root.handleRequestError(err);
						this.loading = false;
					});
			})
		},
		observableAuth() {

			const auth = getAuth()
			return new Promise((success, reject) => {
				onAuthStateChanged(auth, (user) => {
					if (user) {
						success()
					} else {
						if (this.$root.store.state.currentUser != false) {
							this.$root.api.get('/auth/supplier', {})
							.then((res) => {
								let token = res.data.token
								signInWithCustomToken(auth, token)
									.then(() => {
										success()
									}).catch((error) => {
										reject(error)
										console.log('error', error)
									})
							}).catch(err => {
								this.$root.handleRequestError(err);
								this.loading = false;
								reject(err)
							});
						}
					}
				})
			})
		},
		async getDriverTokenFB() {

			var driverDoc  = doc(db, "drivers", String(this.driverId))
			const snapshot = await getDoc(driverDoc);
			if (snapshot.exists()) {
				this.token = snapshot.data().token
			}
		}
	},
	props: {
		selected: {
			type: Array,
			required: true
		},
		show: {
			type: Boolean,
			required: true
		}
	},
	components: {},
	data() {
		return {
			transportUnitId: null,
			driverId: null,
			confirmation: null,
			loading: false,
			token: ''
		};
	},
	computed: {
		showaux: {
			set(val) {
				this.$emit("update:show", val);
			},
			get() {
				return this.show;
			}
		},
		userDriverOpts() {
			let aux = JSON.parse(JSON.stringify(this.$root.auxVars.userDriverOpts));
			aux.unshift({ value: null, text: "N/A" });
			return aux;
		},
		transportUnitsOpts() {
			let aux = JSON.parse(JSON.stringify(this.$root.auxVars.transportUnitsOpts));
			aux.unshift({ value: null, text: "N/A" });
			return aux;
		},
		options: function() {
			const optios = [];
			const elm = this.$t("bookings.AcceptedOptionsMassive");
			Object.keys(elm).forEach(item => {
				optios.push({ value: item, text: elm[item] });
			});
			return optios;
		},
		rowsMessage() {
			return this.$t("AssignConfirmation.rowsMessage").replace(
				"$TOTAL",
				this.selected.length
			);
		},
		messageConfirmationAction() {
			let action = this.$t("bookings.AcceptedOptionsMassive")[
				this.confirmation
			];
			return this.$t("bookings.confirmSupplierConfirmationMassive", {
				action: action.toUpperCase()
			});
		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ["transportUnitsOpts", "userDriverOpts"]
		});
	},
	watch: {}
};
</script>
